var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluvialFloodSr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    height: "100%",
    width: "100%",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill-rule:evenodd;clip-rule:evenodd}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5 24c3.6 0 6.5-2.9 6.5-6.5S21.1 11 17.5 11 11 13.9 11 17.5s2.9 6.5 6.5 6.5zm-3.7-10.2h7.6v1.8h-7.6v-1.8zm0 2.7h1.9V22h-1.9v-5.5zm2.8 0h1.9V22h-1.9v-5.5zm4.7 0h-1.9V22h1.9v-5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m16.2 9.2-3-3.2-6.7 7.6-.1.1c-.2.3-.3.6-.3 1 0 .8.4 1.2.8 1.2h1V17h-.7c-2.5 0-4.2.4-5.1 1.1v2.8c.9-.7 2.6-1.1 5.1-1.1 1.4 0 2.5.3 3.5.7-.4-.9-.6-1.9-.6-3 0-4.1 3.4-7.5 7.5-7.5.6 0 1.2.1 1.8.2V7.9c-.1-.4-.6-.6-1.6-.6s-1.5.2-1.5.7v1.2zM6 10.6C6 9.6 4.5 8 4.5 8S3 9.6 3 10.6c0 .8.7 1.4 1.5 1.4S6 11.4 6 10.6zm4-4C10 5.6 8.5 4 8.5 4S7 5.6 7 6.6C7 7.4 7.7 8 8.5 8S10 7.4 10 6.6zm-5-2C5 3.6 3.5 2 3.5 2S2 3.6 2 4.6C2 5.4 2.7 6 3.5 6S5 5.4 5 4.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluvialFloodSr);
export default __webpack_public_path__ + "static/media/pluvial_flood_sr.f250e89f08f59e5eec0d535b815bca79.svg";
export { ForwardRef as ReactComponent };